<template>
  <div class="d-flex align-items-baseline">
    <label for="" class="font-weight-bold text-white text-sm me-3 custom-select">
      {{ $t('student') }}
    </label>
    <select
      class="form-control form-control-sm"
      name="student-manager"
      required
      id="select-student-manager"
      v-model="state.studentId"
      @change="setStudentManager()"
    >
      <option value="">{{ $t('selectStudent') }}</option>
      <option v-for="(item, index) in state.alunos" :key="index" :value="item.id">
        {{ item.name }} {{ item.surname }}
      </option>
    </select>
  </div>
</template>

<script>
import { reactive, onMounted, ref, inject, watch } from 'vue'
import { useStore } from 'vuex'
import alunoRepository from '../../services/api/alunoRepository'
import planosTreinoRepository from '../../services/api/planosTreinoRepository'
export default {
  setup() {
    const store = useStore()
    const swal = inject('$swal')

    const state = reactive({
      studentId: '',
      alunos: [],
    })

    onMounted(() => {
      store.commit('SET_SPLASH_SCREEN', false)
      if (store.getters.StudentManager != null) {
        state.studentId = store.getters.StudentManager
      }

      listarAlunos()
    })

    const listarAlunos = () => {
      alunoRepository
        .AlunoGet()
        .then((response) => {
          state.alunos = []
          if (response.data.success) {
            state.alunos = response.data.data
          }
        })
        .catch((error) => {
          console.error(error)
          // Silenciosamente ignora o erro de listagem de alunos
          // pois pode ser erro de permissão ou coach sem alunos
        })
    }

    const setStudentManager = async () => {
      let id = parseInt(state.studentId)
      store.commit('SET_STUDENT', id > 0 ? id : null)

      // Se um aluno foi selecionado, buscar o plano de treino ativo
      if (id > 0) {
        try {
          const response = await planosTreinoRepository.PlanosTreinoGet({
            headers: {
              'student-manager': id
            }
          })

          if (response.data.success && response.data.data) {
            const planos = Array.isArray(response.data.data) ? response.data.data : [response.data.data]

            if (planos.length > 0) {
              // ✅ Ordenar planos pelo ID decrescente (mais recente primeiro)
              // ou pela data de criação se disponível
              const planosOrdenados = [...planos].sort((a, b) => {
                // Primeiro tenta ordenar por data de criação
                if (a.created_at && b.created_at) {
                  return new Date(b.created_at) - new Date(a.created_at)
                }
                // Se não tiver data, ordena por ID (maior = mais recente)
                return (b.id || 0) - (a.id || 0)
              })

              // Procurar o plano ativo entre os ordenados
              const planoAtivo = planosOrdenados.find(p => p.active === 1 || p.active === true || p.status === 'active')

              if (planoAtivo) {
                store.commit('SET_TRAINING_PLAN', planoAtivo.id)
                console.log('Plano de treino ativo selecionado automaticamente:', planoAtivo.id)
              } else {
                // Se não encontrar ativo, pega o mais recente
                store.commit('SET_TRAINING_PLAN', planosOrdenados[0].id)
                console.log('Usando plano mais recente:', planosOrdenados[0].id)
              }
            } else {
              store.commit('SET_TRAINING_PLAN', null)
            }
          } else {
            store.commit('SET_TRAINING_PLAN', null)
          }
        } catch (error) {
          console.error('Erro ao buscar plano de treino:', error)
          store.commit('SET_TRAINING_PLAN', null)
        }
      } else {
        store.commit('SET_TRAINING_PLAN', null)
      }

      window.location.reload()
    }
    return {
      state,
      setStudentManager,
    }
  },
}
</script>

<style></style>
